module.exports = __webpack_public_path__ + "img/pr-2.f0ec5cab.png";